import { Currency, PreferredLanguage } from 'fungi-types'

export const saveUserToken = (token: string) => {
  localStorage.setItem('token', token)
}

export const getUserToken = () => {
  console.log('getUserToken called')
  const test = localStorage.getItem('token') || ''
  console.log('getUserToken', test)
  return test
}

type UserInfo = {
  cuid: string
  email: string
  username: string
  preferred_language: PreferredLanguage
  preferred_currency: Currency
  firstName?: string | undefined
  lastName?: string | undefined
}

export const saveUserInfo = (userInfo: UserInfo) => {
  sessionStorage.setItem('user', JSON.stringify(userInfo))
}

export const getUserInfo = (): UserInfo | null => {
  const user = sessionStorage.getItem('user')
  if (!user) return null
  return JSON.parse(user) as UserInfo
}
